<template>
  <service
    data-aos="fade"
    :image="image"
    :title="title"
  >
    <p>
      There is nothing like the intimacy found in sharing a meal — keep your event stress-free
      with Chef Naturelle as your caterer, and let me create memorable experiences for you and
      your guests!
    </p>
    <p>
      My knowledge of ingredients, paired with my innovative and conscious approach to cooking,
      will result in vibrant and nourishing dishes, leaving you to relax and spend quality time
      with your guests.
    </p>
    <p>
      Whether you are planning a birthday party, a family reunion or a get-together with friends,
      you can reach me at <a href="mailto:contact@chefnaturelle.com">contact@chefnaturelle.com</a>
      to discuss your event.
    </p>
  </service>
</template>

<script>
import Service from '@/components/Service'
import MetaInfoBuilder from '@/utils/social'

export default {
  components: {
    Service,
  },
  data: () => ({
    description: '',
    image: require(`@/assets/images/event-catering-banner2.jpg?vuetify-preload`),
    title: 'Event Catering',
  }),
  metaInfo() {
    return new MetaInfoBuilder()
      .description(this.description)
      .image(`${window.location.origin}${this.image.src}`)
      .title(this.title)
      .build()
  }
}
</script>

<style scoped>
</style>
